var _circle, _ellipse, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 37,
    r: 35,
    fill: "#EBF3FE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.7981,
    cy: 25.7322,
    rx: 1.79807,
    ry: 1.80957,
    fill: "#338AF3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 31.8081,
    width: 3.59614,
    height: 18.8195,
    rx: 1.79807,
    fill: "#338AF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1663 6.68238C49.051 3.7044 43.112 2 36.7775 2C17.5704 2 2 17.67 2 37C2 56.33 17.5704 72 36.7775 72C55.9846 72 71.555 56.33 71.555 37C71.555 32.9773 70.8807 29.1131 69.6396 25.5156",
    stroke: "#338AF3",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.eb64db6ed6652359fdd8c345c172c761.svg";
export { ForwardRef as ReactComponent };